import React from 'react';

import SearchIcon from '@mui/icons-material/SearchRounded';

import { IconButton, OutlinedInput } from '@mui/material';

import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router';

import * as Yup from 'yup';
import { Formik, useFormik } from 'formik';
import { useSearchParams } from 'react-router-dom';

export const SearchBar = ({ xs = 'none', md = 'flex' }) => {
    const theme = useTheme();

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = React.useState(searchParams.get('search') || '');

    const searchValidationSchema = Yup.object().shape({
        search: Yup.string().min(1).max(100).required()
    });

    const handleOnSubmitSearch = (values, { setErrors, setStatus, setSubmitting }) => {
        setSubmitting(true);
        navigate(`/explore?search=${values.search}`);
        setSubmitting(false);
    };

    const formik = useFormik({
        initialValues: {
            search: search
        },
        validationSchema: searchValidationSchema,
        onSubmit: handleOnSubmitSearch
    });

    return (
        <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
            <OutlinedInput
                type="search"
                name="search"
                value={formik.values.search}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={Boolean(formik.touched.search && formik.errors.search)}
                placeholder="Search for videos"
                autoComplete="off"
                size="small"
                sx={{ width: { xs: '100%', md: 400 }, display: { xs: xs, md: md } }}
                endAdornment={
                    <IconButton
                        sx={{ backgroundColor: '#dedede', height: '100%', width: 40, position: 'absolute', right: 0 }}
                    >
                        <SearchIcon sx={{ color: theme.palette.grey[700] }} />
                    </IconButton>
                }
            />
        </form>
    );
};

export const SearchBarSmall = ({ xs = 'flex', md = 'none' }) => {
    const theme = useTheme();

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = React.useState(searchParams.get('search') || '');

    const searchValidationSchema = Yup.object().shape({
        search: Yup.string().min(1).max(100).required()
    });

    const handleOnSubmitSearch = (values, { setErrors, setStatus, setSubmitting }) => {
        setSubmitting(true);
        navigate(`/explore?search=${values.search}`);
        setSubmitting(false);
    };

    const formik = useFormik({
        initialValues: {
            search: search
        },
        validationSchema: searchValidationSchema,
        onSubmit: handleOnSubmitSearch
    });

    return (
        <form noValidate autoComplete="off" onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
            <OutlinedInput
                type="search"
                name="search"
                value={formik.values.search}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={Boolean(formik.touched.search && formik.errors.search)}
                placeholder="Search for videos"
                autoComplete="off"
                size="small"
                sx={{ width: { xs: '100%', md: 400 }, display: { xs: xs, md: md } }}
                endAdornment={
                    <IconButton
                        sx={{ backgroundColor: '#dedede', height: '100%', width: 40, position: 'absolute', right: 0 }}
                    >
                        <SearchIcon sx={{ color: theme.palette.grey[700] }} />
                    </IconButton>
                }
            />
        </form>
    );
};
